import {
  VStack,
  useToast,
  Tbody,
  Tr,
  Td,
  Heading,
  Table,
  Thead,
  Th,
  Button,
  FormControl,
  FormLabel,
  Input,
  Grid,
  Box,
} from "@chakra-ui/react";
import {useState, useEffect} from "react";
import {fetchRelations} from "./helpers/fetchRelations";
import {addRelation} from "./helpers/addRelation";
import CustomSelectField from "./Fields/CustomSelectField.jsx";
import {nanoid} from "nanoid";

export default function Relations({state, dispatch}) {
  const patient = state.patient;
  const [relations, setRelations] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [newRelation, setNewRelation] = useState({
    rid: nanoid(10),
    pid: patient.pid,
  });
  const toast = useToast();

  useEffect(() => {
    fetchRelations(setRelations, state, patient, toast);
  }, []);

  const validateRelationField = (field, value) => {
    if (!value || !relations) return;
    const duplicate = relations.find((r) => r[field] === value);
    if (duplicate) {
      const label = field === "email" ? "email" : "phone number";
      toast({
        title: `Enter different ${label}`,
        description: `A relation with this ${label} already exists`,
        status: "error",
        isClosable: true,
      });
      setNewRelation((prev) => ({...prev, [field]: ""}));
    }
  };

  return (
    <Box w="full" px={0} py={2}>
      <Box
        bg="gray.50"
        borderRadius="12px"
        px={{base: 4, md: 6}}
        py={{base: 4, md: 6}}
        mb={4}
      >
        <VStack spacing={4} alignItems="stretch">
          <Heading as="h3" size="sm" color="gray.800">
            Relations' Accounts
          </Heading>
          <Box w="full" overflowX="auto">
            <Table size="sm" w="full" minW="520px">
              <Thead>
                <Tr>
                  <Th textAlign="center">Name</Th>
                  <Th textAlign="center">Relation</Th>
                  <Th textAlign="center">Email</Th>
                  <Th textAlign="center">Phone</Th>
                </Tr>
              </Thead>
              <Tbody>
                {relations?.length > 0 ? (
                  relations.map((r, i) => (
                    <Tr key={i}>
                      <Td textAlign="center">{r.name}</Td>
                      <Td textAlign="center">{r.relation}</Td>
                      <Td textAlign="center">{r.email}</Td>
                      <Td textAlign="center">{r.phone}</Td>
                    </Tr>
                  ))
                ) : (
                  <Tr>
                    <Td colSpan={4} textAlign="center">
                      No relations' accounts created
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </Box>

        <form
          style={{width: "100%"}}
          onSubmit={(e) =>
            addRelation(
              e,
              newRelation,
              state,
              setRelations,
              patient,
              setIsLoading,
              toast
            )
          }
        >
          <VStack spacing={4}>
            <Heading size="sm" my="6">
              Add a new relation
            </Heading>
            <Grid
              templateColumns={{
                base: "1fr",
                md: "repeat(2, 1fr)",
                xl: "repeat(4, 1fr)",
              }}
              gap={3}
            >
              <FormControl id="name">
                <FormLabel>Name</FormLabel>
                <Input
                  size="sm"
                  variant="outline"
                  borderRadius="md"
                  type="text"
                  placeholder="John Doe"
                  value={newRelation.name || ""}
                  onChange={(e) =>
                    setNewRelation({...newRelation, name: e.target.value})
                  }
                />
              </FormControl>

              <CustomSelectField
                id="relation"
                label="Relationship to Patient"
                value={newRelation.relation || ""}
                onChange={(e) =>
                  setNewRelation({...newRelation, relation: e.target.value})
                }
                options={[
                  "Mother",
                  "Father",
                  "Sibling",
                  "Grandparent",
                  "Legal Guardian",
                  "Other Relative",
                  "Friend",
                  "Acquaintance",
                ].map((option) => ({label: option, value: option}))}
              />

              <FormControl id="email">
                <FormLabel>Email</FormLabel>
                <Input
                  size="sm"
                  variant="outline"
                  borderRadius="md"
                  type="email"
                  placeholder="john.doe@example.com"
                  value={newRelation.email || ""}
                  onChange={(e) =>
                    setNewRelation({...newRelation, email: e.target.value})
                  }
                  onBlur={(e) => validateRelationField("email", e.target.value)}
                />
              </FormControl>

              <FormControl id="phoneNumber">
                <FormLabel>Phone Number</FormLabel>
                <Input
                  size="sm"
                  variant="outline"
                  borderRadius="md"
                  type="tel"
                  placeholder="123-456-7890"
                  value={newRelation.phone || ""}
                  onChange={(e) =>
                    setNewRelation({...newRelation, phone: e.target.value})
                  }
                  onBlur={(e) => validateRelationField("phone", e.target.value)}
                />
              </FormControl>
            </Grid>
            <Button
              isLoading={isLoading}
              variant="outline"
              borderColor="gray.300"
              bg="white"
              type="submit"
              my={3}
              px="8"
              size="sm"
            >
              Add Relation
            </Button>
          </VStack>
        </form>
        </VStack>
      </Box>
    </Box>
  );
}
